export const environment = {
  production: false,
  domain: 'https://dev.gymerzapp.com',
  imagesDomain: 'https://dev.gymerzapp.com'
};
